export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-75--g1.96dc879a.png";